import { Component, Input, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';

@Component({
  selector: 'app-gift-card-preview',
  templateUrl: './gift-card-preview.component.html',
  styleUrls: ['./gift-card-preview.component.scss'],
})
export class GiftCardPreviewComponent implements OnInit {
  @Input() titleSection = '';
  @Input() typeOfConsumption = '';
  public giftCards: any[] = [];
  public options = {
    breakpoints: {
      220: {
        slidesPerView: 1.1,
      },
      578: {
        slidesPerView: 3.1,
      },
      1024: {
        slidesPerView: 4.1,
      },
    },
  };

  constructor(private httpSv: HttpService) {}

  async ngOnInit() {
    const params = {
      typeOfConsumption: this.typeOfConsumption,
    };
    const res = await this.httpSv.itemIndex('giftCard/user', '', params);
    this.giftCards = res.data;
  }
}
